import { DecoratorNode, $applyNodeReplacement } from 'lexical';
import React from 'react';
import PropTypes from 'prop-types';

const PRIORITY_ABOVE_DEFAULT_LINK_NODE_IMPORT = 2;

function EmbedComponent({ html }) {
  return <div className="editor-embed" dangerouslySetInnerHTML={{ __html: html }} />;
}

EmbedComponent.propTypes = {
  html: PropTypes.string.isRequired
};

export class EmbedNode extends DecoratorNode {
  static getType() {
    return 'embed';
  }

  static clone(node) {
    return new EmbedNode(node.__html, node.__key);
  }

  static importJSON(serializedNode) {
    return $createEmbedNode(serializedNode.html);
  }

  exportJSON() {
    return {
      type: 'embed',
      version: 1,
      html: this.__html
    };
  }

  static importDOM() {
    const matchEmbeddableElement = domNode => ({
      conversion: () => ({ node: $createEmbedNode(domNode.outerHTML) }),
      priority: 1
    });
    const matchDownloadLink = domNode => {
      if (!domNode.hasAttribute('download')) return null;
      return {
        conversion: () => ({ node: $createEmbedNode(domNode.outerHTML) }),
        priority: PRIORITY_ABOVE_DEFAULT_LINK_NODE_IMPORT
      };
    };

    return {
      iframe: matchEmbeddableElement,
      audio: matchEmbeddableElement,
      video: matchEmbeddableElement,
      a: matchDownloadLink
    };
  }

  exportDOM() {
    const template = document.createElement('template');
    template.innerHTML = this.__html.trim();
    const element = template.content.firstElementChild;
    return { element: element || document.createElement('span') };
  }

  constructor(html, key) {
    super(key);
    this.__html = html;
  }

  createDOM() {
    return document.createElement('div');
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return <EmbedComponent html={this.__html} />;
  }
}

export function $createEmbedNode(html) {
  return $applyNodeReplacement(new EmbedNode(html));
}

export function $isEmbedNode(node) {
  return node instanceof EmbedNode;
}
